import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import type { TicketOption } from '../models/changeTicket';

export const useChangeTicketModalStore = defineStore(
  'ChangeTicketModalStore',
  () => {
    // State
    const selectedTicketType = ref<string>('notInitialized');
    const ticketOptions = ref<TicketOption[]>([]);

    // Actions
    function initializeStore(initialOptions: TicketOption[]): void {
      const selected = initialOptions.find(
        (option: TicketOption) => option.selected
      );

      if (!selected) {
        throw new Error('Ticket option must be selected!');
      }

      selectedTicketType.value = selected.type;
      ticketOptions.value = initialOptions;
    }

    function selectTicketType(ticketType: string): void {
      selectedTicketType.value = ticketType;
    }

    // Getters
    const basePrice = computed<number>(() => {
      const selected = ticketOptions.value.find(
        (ticketOption: TicketOption) =>
          ticketOption.type === selectedTicketType.value
      );

      if (!selected) {
        throw new Error('Ticket option must be selected!');
      }

      return selected.price;
    });

    return {
      // State
      selectedTicketType,

      // Actions
      initializeStore,
      selectTicketType,
      basePrice,
    };
  }
);
